import { atom } from 'recoil';
import { DateFilterState, DefaultDateFilter, useDateFilter } from './dateFilter';
import { PaymentDetail } from 'types';

type Sort = {
    text: string,
    compare: (a: PaymentDetail, b: PaymentDetail) => number
};

const getDeductionDate = ({ paymentDate, scheduledPayDate, invoiceDate }: PaymentDetail) =>
    (paymentDate ?? scheduledPayDate ?? invoiceDate)?.getTime() ?? 0;

export const DeductionsSortOptions: Sort[] = [
    {
        text: 'Sort By',
        compare: () => 0
    },
    {
        text: 'Date: Descending',
        compare: (a, b) => getDeductionDate(b) - getDeductionDate(a)
    },
    {
        text: 'Date: Ascending',
        compare: (a, b) => getDeductionDate(a) - getDeductionDate(b)
    },
    {
        text: 'Amount: High to Low',
        compare: (a, b) => b.adjustmentAmount - a.adjustmentAmount
    },
    {
        text: 'Amount: Low to High',
        compare: (a, b) => a.adjustmentAmount - b.adjustmentAmount
    }
];

export type DeductionFilterState = {
    startAmount?: number,
    endAmount?: number,
    deductionType?: number,
    dotBillbackType?: string,
    customerId?: string,
    searchTerm?: string,
    sort: Sort
} & DateFilterState;

export const deductionsFilter = atom<DeductionFilterState>({
    key: 'deductionsFilter',
    default: {
        ...DefaultDateFilter,
        sort: DeductionsSortOptions[1]
    }
});

export const useDeductionsFilter = () => {
    const { setField, ...state } = useDateFilter(deductionsFilter);

    return {
        ...state,
        setStartAmount: (value?: number) => setField('startAmount', value),
        setEndAmount: (value?: number) => setField('endAmount', value),
        setDeductionType: (value?: number) => setField('deductionType', value),
        setDotBillbackType: (value?: string) => setField('dotBillbackType', value),
        setCustomerId: (value?: string) => setField('customerId', value),
        setSearchTerm: (value?: string) => setField('searchTerm', value),
        setSort: (value: Sort) => setField('sort', value)
    };
};
